export default "__VITE_ASSET__BT6cALcf__"